import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

const FR = (
  <>
    <section>
      <h2>1. Éditeur du site</h2>
      <p>
        Le site adonis-agency.eu est édité par Valentin BECHAMEIL, entrepreneur
        individuel.
      </p>
      <p className="text-sm text-slate-500 italic">
        (Adonis Agency, SAS en cours de constitution, exploitée à titre
        individuel par Valentin BECHAMEIL dans l'attente de son immatriculation.)
      </p>
      <ul>
        <li>Adresse : 61 rue de Lyon, 75012 Paris, France</li>
        <li>SIREN : 947 597 696</li>
        <li>TVA non applicable, article 293 B du CGI</li>
        <li>
          E-mail :{" "}
          <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>
        </li>
      </ul>
    </section>

    <section>
      <h2>2. Directeur de la publication</h2>
      <p>
        Le directeur de la publication est Valentin BECHAMEIL, en sa qualité
        d'éditeur du site. Contact :{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>.
      </p>
    </section>

    <section>
      <h2>3. Hébergement</h2>
      <p>
        Le site est hébergé par Axeris Labs, 61 rue de Lyon, 75012 Paris, France.
      </p>
      <p>
        Site web :{" "}
        <a href="https://www.axeris-labs.fr" target="_blank" rel="noopener noreferrer">
          https://www.axeris-labs.fr
        </a>
      </p>
    </section>

    <section>
      <h2>4. Propriété intellectuelle</h2>
      <p>
        L'ensemble des contenus du site (textes, images, vidéos, logos,
        supports de formation, structure et charte graphique) est protégé par
        le droit de la propriété intellectuelle et demeure la propriété
        exclusive de Valentin BECHAMEIL / Adonis Agency, sauf mention contraire.
        Toute reproduction, représentation, modification, extraction ou
        exploitation, totale ou partielle, sans autorisation écrite préalable,
        est interdite et constitue une contrefaçon. L'accès aux contenus de
        formation est strictement personnel et réservé aux personnes inscrites ;
        tout partage des accès ou des supports est prohibé.
      </p>
    </section>

    <section>
      <h2>5. Données personnelles</h2>
      <p>
        Le traitement des données collectées via le site est décrit dans notre{" "}
        <a href="/privacy">Politique de confidentialité</a>. Conformément au
        RGPD et à la loi Informatique et Libertés, vous disposez de droits
        d'accès, de rectification, d'effacement, d'opposition, de limitation et
        de portabilité, exerçables à{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>.
      </p>
    </section>

    <section>
      <h2>6. Responsabilité</h2>
      <p>
        L'éditeur s'efforce d'assurer l'exactitude des informations diffusées
        sans pouvoir en garantir l'exhaustivité. Les contenus de formation
        sont fournis à titre informatif et pédagogique ; ils ne constituent pas
        un conseil juridique, fiscal, comptable ou financier personnalisé.
      </p>
    </section>

    <section>
      <h2>7. Accès au site</h2>
      <p>
        L'accès au site et aux services est réservé aux personnes majeures
        (18 ans et plus).
      </p>
    </section>

    <section>
      <h2>8. Droit applicable</h2>
      <p>Les présentes mentions sont soumises au droit français.</p>
    </section>
  </>
);

const EN = (
  <>
    <section>
      <h2>1. Publisher</h2>
      <p>
        The site adonis-agency.eu is published by Valentin BECHAMEIL, sole
        trader.
      </p>
      <p className="text-sm text-slate-500 italic">
        (Adonis Agency, SAS in formation, currently operated as a sole
        proprietorship by Valentin BECHAMEIL pending registration.)
      </p>
      <ul>
        <li>Address: 61 rue de Lyon, 75012 Paris, France</li>
        <li>SIREN: 947 597 696</li>
        <li>VAT not applicable, article 293 B of the French Tax Code</li>
        <li>
          Email:{" "}
          <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>
        </li>
      </ul>
    </section>

    <section>
      <h2>2. Publication director</h2>
      <p>
        The publication director is Valentin BECHAMEIL, as publisher of the
        site. Contact:{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>.
      </p>
    </section>

    <section>
      <h2>3. Hosting</h2>
      <p>
        This site is hosted by Axeris Labs, 61 rue de Lyon, 75012 Paris, France.
      </p>
      <p>
        Website:{" "}
        <a href="https://www.axeris-labs.fr" target="_blank" rel="noopener noreferrer">
          https://www.axeris-labs.fr
        </a>
      </p>
    </section>

    <section>
      <h2>4. Intellectual property</h2>
      <p>
        All site contents (texts, images, videos, logos, training materials,
        structure and visual identity) are protected by intellectual property
        law and remain the exclusive property of Valentin BECHAMEIL / Adonis
        Agency, unless stated otherwise. Any reproduction, representation,
        modification, extraction or exploitation, in whole or in part, without
        prior written authorization, is prohibited and constitutes
        infringement. Access to training contents is strictly personal and
        reserved to enrolled persons; any sharing of credentials or materials
        is prohibited.
      </p>
    </section>

    <section>
      <h2>5. Personal data</h2>
      <p>
        Processing of personal data collected on the site is described in our{" "}
        <a href="/privacy">Privacy policy</a>. Under the GDPR and the French
        Data Protection Act you have rights of access, rectification, erasure,
        objection, restriction and portability, exercisable at{" "}
        <a href="mailto:contact@adonis-agency.eu">contact@adonis-agency.eu</a>.
      </p>
    </section>

    <section>
      <h2>6. Liability</h2>
      <p>
        The publisher strives to ensure the accuracy of the information
        published, without guaranteeing its completeness. Training contents are
        provided for information and educational purposes; they do not
        constitute personalized legal, tax, accounting or financial advice.
      </p>
    </section>

    <section>
      <h2>7. Site access</h2>
      <p>
        Access to the site and services is restricted to adults (18 years old
        and over).
      </p>
    </section>

    <section>
      <h2>8. Applicable law</h2>
      <p>This legal notice is governed by French law.</p>
    </section>
  </>
);

export default function LegalNotice() {
  const { i18n } = useTranslation();
  const isFR = (i18n.language || "fr").startsWith("fr");
  return (
    <LegalLayout
      testId="legal-page"
      kickerKey="legal.kicker_long"
      titleKey="footer.legal"
    >
      {isFR ? FR : EN}
    </LegalLayout>
  );
}
